import BoardContentInformationApi from '@app/api/public/BoardContentInformationApi';
import { useMutation, useQueryClient } from 'react-query';
import { boardInformationQueryKeys } from './boardInformationQueries';

type Variables = { id: number; notify: boolean };

const usePublishInformation = () => {
    const client = useQueryClient();
    return useMutation(
        (varables: Variables) => {
            return BoardContentInformationApi.publishInformation(varables);
        },
        {
            onSettled: () => {
                client.invalidateQueries(boardInformationQueryKeys.all);
            },
        }
    );
};

export default usePublishInformation;
